import { jsx } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { useSlotProps } from "../../base/index.js";
import { useComponentsProps } from "./hooks/useComponentsProps.js";
import { useGetOptionDisabled } from "./hooks/useGetOptionDisabled.js";
import { useOnBlur } from "./hooks/useOnBlur.js";
import { useRenderInput } from "./hooks/useRenderInput.js";
import { useRenderOption } from "./hooks/useRenderOption/index.js";
import { useTexts } from "./hooks/useTexts.js";
import { Root } from "./components/Root.js";
import { VirtualListboxComponent } from "./components/VirtualListboxComponent.js";
import { selectName, useSelectUtilityClasses } from "./classes.js";
function Select(inProps) {
  const props = useThemeProps({
    name: selectName,
    props: inProps
  });
  const {
    testId = `${selectName}-root`,
    selectState: {
      props: componentProps,
      props: {
        className = "",
        disabled,
        disableClearOnBlur,
        items,
        // TODO: ItemTooltip,
        onFocus,
        value,
        size
      },
      actions: { onChange },
      filterOptions,
      getOptionLabel,
      isOptionEqualToValue
    }
  } = props;
  const autocompleteProps = {
    size,
    ...props.selectState.props.autocompleteProps
  };
  const texts = useTexts();
  const renderInput = useRenderInput(props, filterOptions);
  const renderOption = useRenderOption(props);
  const componentsProps = useComponentsProps(autocompleteProps?.componentsProps);
  const getOptionDisabled = useGetOptionDisabled(props);
  const onBlur = useOnBlur(props);
  const ListboxComponent = componentProps.listMode === "virtual" ? VirtualListboxComponent : void 0;
  const ownerState = componentProps;
  const utilityClasses = useSelectUtilityClasses(ownerState);
  const rootSlotProps = useSlotProps({
    className: `${className} ${utilityClasses.root}`,
    ownerState,
    elementType: Root,
    externalSlotProps: {},
    externalForwardedProps: autocompleteProps
  });
  return /* @__PURE__ */ jsx(
    Root,
    {
      fullWidth: true,
      ...rootSlotProps,
      value,
      onBlur,
      options: items,
      onChange,
      onFocus,
      disabled,
      clearOnBlur: !disableClearOnBlur,
      renderInput,
      "data-testid": testId,
      "data-tidal": selectName,
      renderOption,
      filterOptions,
      noOptionsText: texts.noOptions,
      getOptionLabel,
      componentsProps,
      ListboxComponent,
      getOptionDisabled,
      isOptionEqualToValue
    }
  );
}
export {
  Select
};
//# sourceMappingURL=Select.js.map
